import React, { Component } from "react";

import { getPlans } from "features/new/collective/requests/get-plans";

import CollectiveView from "features/new/collective/component/view";

class Collective extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plans: [],
      activePlan: 0,
    };

    this.changePlan = this.changePlan.bind(this);
  }

  componentDidMount() {
    getPlans().then((response) => this.setState({ plans: response.data.data }));
  }

  changePlan(index) {
    this.setState({ activePlan: index });
  }

  render() {
    const { plans, activePlan } = this.state;

    return (
      <CollectiveView
        plans={plans}
        activePlan={activePlan}
        changePlan={this.changePlan}
      />
    );
  }
}

export default Collective;
